import Header from '../../components/admin/header/Header'

import Detail from '../../components/admin/event/Detail';

export default function EventDetail() {
  return (
    <>
      <Header></Header>
      <Detail />
    </>
  );
}
